import React from 'react'
import propTypes from 'prop-types'

const ValidationErrorList = (props) => {
  const {validationErrors} = props
  return (
      <ul>
        {validationErrors.map((error, index) => {
          return (
              <li key={`validation-error-${index}`}>
                {error}
              </li>
          )
        })}
      </ul>
  )
}

ValidationErrorList.propTypes = {
  validationErrors: propTypes.array,
}

export default ValidationErrorList
